export default (app) => {
    let appConfig = app.config
    appConfig.appKey = "";

    let storage = {
        setCookie: function (name, value, expires) {
            name += appConfig.appKey;
            if (typeof value !== "string") value = JSON.stringify(value);

            if (expires == undefined) {
                document.cookie = name + "=" + escape(value) + ";";
            }
            else {
                var exdate = new Date();
                exdate.setDate(exdate.getDate() + expires);
                document.cookie = name + "=" + escape(value) + ";expires=" + exdate.toGMTString();
            }
        },
        //取得cookie的值
        getCookie: function (name) {
            name += appConfig.appKey;

            var regStr = name + "=([^;]*)";
            var arr = document.cookie.match(new RegExp(regStr));
            if (arr != null) return unescape(arr[1]);
            else return "";
        },
        //删除cookie
        deleteCookie: function (name) {
            name += appConfig.appKey;
            if (document.cookie.indexOf(name) === -1) return;
            //删除一个cookie，就是将其过期时间设定为一个过去的时间
            var ck = name + "=;expires=" + new Date('2000/01/01');
            document.cookie = ck;
        },
        //保存数据到本地
        saveLocal: function (key, value) {
            if (localStorage) {
                key += appConfig.appKey;
                if (typeof value !== "string") value = JSON.stringify(value);
                value = escape(value);
                localStorage.setItem(key, value);
            }
            else {
                this.setCookies(key, value, 30);
            }
        },
        //从本地获取指定的数据
        getLocal: function (key) {
            if (localStorage) {
                key += appConfig.appKey;
                var result = null;
                try {
                    result = localStorage.getItem(key) || "";
                    result = unescape(result);
                } catch (e) { result = null; }
                return result;
            }
            else {
                return this.getCookies(key);
            }
        },
        //key不传就删除该项目所有的本地数据
        deleteLocal: function (key) {
            if (localStorage) {
                if (key) {
                    key += appConfig.appKey;
                    localStorage.removeItem(key);
                }
                else {
                    if (localStorage.length > 0) {
                        for (var length = localStorage.length, i = length - 1; i >= 0; i--) {
                            if (localStorage.key(i).indexOf(appConfig.appKey) !== -1)
                                localStorage.removeItem(localStorage.key(i));
                        }
                    }
                }
            }
            else {
                this.delCookies(key);
            }
        }
    }
    return { storage };
} 